export function copyHref(elem) {
	navigator.clipboard.writeText($(elem).attr('href'));
	return false;
}
